import { Button, AlertBanner } from "snap-design-system";
import { Check, LogOut } from "lucide-react";
import { AiOutlineLoading3Quarters } from "react-icons/ai";

interface LogoutMessageConfirmationProps {
  onConfirm?: () => void;
  onCancel?: () => void;
}

interface LogoutMessageConfirmationFooterProps {
  onConfirm?: () => void;
  onCancel?: () => void;
  isLoading?: boolean;
}

function LogoutMessageConfirmation({ }: LogoutMessageConfirmationProps) {
  return (
    <div className="space-y-4">
      <AlertBanner
        variant="accent"
        icon={<LogOut className="size-5" />}
        title="Você confirma o aceite do convite?"
        message="Ao clicar em SIM, sua sessão atual terminará e você será redirecionado à tela de login."
      />
    </div>
  );
}

function LogoutMessageConfirmationFooter({ onConfirm, onCancel, isLoading }: LogoutMessageConfirmationFooterProps) {
  return (
    <div className="flex gap-3 justify-end">
      <Button
        onClick={onCancel}
        variant={"ghost"}>
        Voltar
      </Button>
      <Button
        onClick={onConfirm}
        icon={isLoading ? <AiOutlineLoading3Quarters size={16} className="animate-spin" /> : <Check size={16} />}
        iconPosition="right"
        disabled={isLoading}
      >
        Sim
      </Button>
    </div>
  );
}

export const LogoutMessageDialog = {
  Content: LogoutMessageConfirmation,
  Footer: LogoutMessageConfirmationFooter
};